import { Box, Button, Stack, Typography } from '@mui/material';

import { enqueueSnackbar } from 'notistack';

import { downloadLatestReport, useGenerateReport } from '@/api/report/report';

interface ReportPageProps {
  outputID: string;
}

const ReportPage = ({ outputID }: ReportPageProps) => {
  const generateReport = useGenerateReport();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleGenerateReport = async () => {
    try {
      await generateReport.mutateAsync({
        outputId: outputID!,
        reportType: 'TEST', // You can make this dynamic if needed
      });

      enqueueSnackbar('Report generation started', { variant: 'success' });
    } catch (error) {
      enqueueSnackbar('Failed to generate report', { variant: 'error' });
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleDownloadReport = async () => {
    try {
      const response = await downloadLatestReport(outputID!);
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `report_${outputID}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      enqueueSnackbar('Report downloaded', { variant: 'success' });
    } catch (error) {
      enqueueSnackbar('Failed to download report', { variant: 'error' });
    }
  };

  return (
    <Stack direction="column" spacing={4} sx={{ px: 3, py: 4 }}>
      {/* DataGrid Section */}
      <Box>
        <Typography variant="h6" gutterBottom>
          Report Generation
        </Typography>

        <Stack direction="row" spacing={1}>
          <Button
            variant="contained"
            color="success"
            size="small"
            onClick={handleGenerateReport}
          >
            Generate Report
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={handleDownloadReport}
          >
            Download Report
          </Button>
        </Stack>
      </Box>
    </Stack>
  );
};

export default ReportPage;
